import { Directive, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";

@Directive({ selector: "[modWhiteBackground]" }) export class BackgroundModifierDirective {
    @Input() @BooleanAttribute() @HostBinding("class.u-background-color-none") public modWhiteBackground: boolean;
}
